import React, { createContext, useState, useContext, useEffect, useMemo, useCallback } from 'react';
import { authApi } from '../api/auth.api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        const response = await authApi.me();
        if (mounted) setAdmin(response.data);
      } catch (error) {
        if (mounted) setAdmin(null);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    checkAuth();

    return () => { mounted = false; };
  }, []);

  const login = useCallback(async (email, password) => {
    const response = await authApi.login({ email, password });
    setAdmin(response.data);
    return response.data;
  }, []);

  const logout = useCallback(async () => {
    await authApi.logout();
    setAdmin(null);
  }, []);

  const value = useMemo(() => ({
    admin,
    loading,
    login,
    logout,
    isAuthenticated: !!admin,
    isSuperAdmin: admin?.role?.name === 'superadmin',
    isAdmin: ['superadmin', 'admin'].includes(admin?.role?.name)
  }), [admin, loading, login, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
